import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import DeleteButton from "../general/DeleteButton.js";
import GeneralTr from "../table-componets/GeneralTr.js";
import DateTr from "../table-componets/DateTr.js";
import DateOfBirthTr from "../table-componets/DateOfBirthTr.js";
import EmailTr from "../table-componets/EmailTr.js";
import PhoneNumberTr from "../table-componets/PhoneNumberTr.js";
import GeneralTd from "../table-componets/GeneralTd.js";
import EmailTd from "../table-componets/EmailTd.js";
import PhoneNumberTd from "../table-componets/PhoneNumberTd.js";
import ButtonTd from "../table-componets/ButtonTd.js";

class Member extends React.Component {
  renderImg(member) {
    return (
      <img
        src={member.avatar_url}
        style={{ height: "32px", width: "32px" }}
        className="img-circle"
        alt={member.first_name}
      />
    );
  }

  renderHouseholdBody() {
    var that = this;
    var members = [];

    _.forEach(this.props.household, function(member, index) {
      members.push(
        <tr key={index}>
          <td>
            <a className="styled-link" href={"/members/" + member.id}>
              {that.renderImg(member)}
            </a>
          </td>
          <td>
            <span className="margin-right-five">{member.last_name}</span>

            {member.imported_household_id && (
              <span
                className="margin-right-five"
                data-tip="Imported household ID"
              >
                {"(" + member.imported_household_id + ")"}
                <ReactTooltip />
              </span>
            )}

            {member.primary && (
              <span data-tip="Primary member of household">
                <span className="badge">Primary</span>
                <ReactTooltip />
              </span>
            )}
          </td>
          <GeneralTd fieldValue={member.first_name} />
          <EmailTd fieldValue={member.email} fieldClassName="hidden-xs" />
          <PhoneNumberTd
            fieldValue={member.phone_number}
            fieldClassName="hidden-xs"
          />
          <ButtonTd
            fieldName="EDIT"
            fieldURL={"/households/" + member.household_id + "/edit"}
            fieldClassName="hidden-xs"
          />
          <ButtonTd
            fieldName="VIEW"
            fieldURL={"/households/" + member.household_id}
          />
        </tr>
      );
    });

    return <tbody>{members}</tbody>;
  }

  renderGroupLessonsBody() {
    var that = this;
    var groupLessons = [];

    _.forEach(this.props.groupLessons, function(groupLesson, index) {
      groupLessons.push(
        <tr key={index}>
          <GeneralTd fieldValue={groupLesson.location.name} />
          <GeneralTd fieldValue={groupLesson.group_lesson_program.name} />
          <GeneralTd fieldValue={groupLesson.abbreviated_days} />
          <GeneralTd fieldValue={groupLesson.times} />
          <GeneralTd fieldValue={groupLesson.session} />
          <ButtonTd
            fieldName="VIEW"
            fieldURL={"/group_lessons/" + groupLesson.id}
          />
        </tr>
      );
    });

    return <tbody>{groupLessons}</tbody>;
  }

  renderReportCardsBody(memberId) {
    var that = this;
    var reportCardsSummary = [];
    var reportCardLevelsSummary = [];

    _.forEach(this.props.reportCards, function(reportCard, rcIndex) {
      _.forEach(reportCard.active_report_card_levels, function(reportCardLevel, rclIndex) {
        reportCardLevelsSummary.push(
          <tr key={"rcl-" + rclIndex}>
            <GeneralTd fieldValue={reportCardLevel.name} />
            <GeneralTd fieldValue={reportCardLevel.display_status} />
            <GeneralTd fieldValue={reportCardLevel.latest_at_this_level ? "" : "Repeated"} />
            <td />
            <td />
          </tr>
        );
      });

      reportCardsSummary.push(
        <div className="shadowDepth1">
          <table className="table table-clean table-white table-report-cards" key={"rc-" + rcIndex}>
            <thead>
              <tr>
                <th>{reportCard.name}</th>
                <th>{reportCard.display_status}</th>
                <th></th>
                <ButtonTd
                  fieldName="VIEW"
                  fieldURL={"/report_cards/" + reportCard.id}
                />
                <td>
                  <DeleteButton
                    fieldId={reportCard.id}
                    fieldURL={"/report_cards/"}
                    fieldToast="Report Card deleted"
                    redirectURL={"/members/"+memberId}
                    confirmMessage="Are you sure you want to delete this report card?"
                  />
                </td>
              </tr>
            </thead>
            <tbody>
              {reportCardLevelsSummary}
            </tbody>
          </table>
        </div>
      );

      reportCardLevelsSummary = [];

    });

    return <div>{reportCardsSummary}</div>;
  }

  getMemberRole(role) {
    switch(role){
      case 0:
        return "Adult";
      case 1:
        return "Child";
      default:
        return "";
    }
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>
          {that.props.photoUrl != null && (
            <img
              src={that.props.photoUrl}
              alt="Member Photo"
              title={
                that.props.member.first_name +
                " " +
                that.props.member.last_name +
                " Photo"
              }
              height="65"
              width="65"
              className="img-circle"
            />
          )}
          {that.props.member.full_name}
        </h1>

        <div className="pull-right">
          <a
            href={"/members/" + that.props.member.id + "/edit"}
            className="btn btn-pink btn-raised btn-long margin-right-five"
          >
            EDIT
          </a>

          {that.props.currentUser.admin && (
            <DeleteButton
              fieldId={that.props.member.id}
              fieldURL={"/members/"}
              fieldToast="Member deleted"
              confirmMessage="Are you sure you want to delete this member?"
            />
          )}
        </div>
        <br />
        <br />
        <br />
        <div className="shadowDepth1">
          <table className="table table-bordered table-white">
            <tbody>
              <GeneralTr
                fieldName={"Primary"}
                fieldValue={that.props.member.primary ? "Yes" : "No"}
              />
              <GeneralTr
                fieldName={"Role"}
                fieldValue={this.getMemberRole(that.props.member.role)}
              />
              <DateTr
                fieldName={"Expiration Date"}
                fieldValue={that.props.member.expiration_date}
              />
              <GeneralTr
                fieldName={"Gender"}
                fieldValue={that.props.member.gender}
              />
              <DateOfBirthTr
                fieldName={"Date of Birth"}
                fieldValue={that.props.member.date_of_birth}
              />
              <EmailTr
                fieldName={"Email"}
                fieldValue={that.props.member.email}
              />
              <PhoneNumberTr
                fieldName={"Phone Number"}
                fieldValue={that.props.member.phone_number}
              />
              <GeneralTr
                fieldName={"Address Line 1"}
                fieldValue={that.props.member.address1}
              />
              <GeneralTr
                fieldName={"Address Line 2"}
                fieldValue={that.props.member.address2}
              />
              <GeneralTr
                fieldName={"City"}
                fieldValue={that.props.member.city}
              />
              <GeneralTr
                fieldName={"State"}
                fieldValue={that.props.member.state}
              />
              <GeneralTr
                fieldName={"Zip Code"}
                fieldValue={that.props.member.zipcode}
              />
              {that.props.member.imported_household_id && (
                <GeneralTr
                  fieldName={"Imported Household ID"}
                  fieldValue={that.props.member.imported_household_id}
                />
              )}
              {that.props.member.imported_member_id && (
                <GeneralTr
                  fieldName={"Imported Member ID"}
                  fieldValue={that.props.member.imported_member_id}
                />
              )}
              <GeneralTr
                fieldName={"Member Type"}
                fieldValue={
                  that.props.member.member_type_id
                    ? that.props.member.member_type.name
                    : "-"
                }
              />
              <GeneralTr
                fieldName={"Emergency Contact"}
                fieldValue={that.props.member.emergency_contact_full_name}
              />
              <GeneralTr
                fieldName={"Emergency Contact Phone Number"}
                fieldValue={that.props.member.emergency_contact_phone_number}
              />
              <GeneralTr
                fieldName={"Allergies"}
                fieldValue={that.props.member.allergies}
              />
            </tbody>
          </table>
        </div>
        <br />
        <h4>Household</h4>
        <div className="shadowDepth1">
          <table className="table table-clean table-white">
            <thead>
              <tr>
                <th />
                <th>Last Name</th>
                <th>First Name</th>
                <th className="hidden-xs">Email</th>
                <th className="hidden-xs">Phone Number</th>
                <th />
              </tr>
            </thead>
            {this.renderHouseholdBody()}
          </table>
        </div>

        {this.props.currentAccount.group_lessons_toggle && (
          <div>
            <br />
            <h4>Lessons</h4>
            <div className="shadowDepth1">
              {that.props.groupLessons.length > 0 ? (
                <table className="table table-clean table-white">
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Program</th>
                      <th>Days</th>
                      <th>Time</th>
                      <th>Session</th>
                      <th />
                    </tr>
                  </thead>
                  {this.renderGroupLessonsBody()}
                </table>
              ) : (
                <div className="shadowDepth1 well grey-text center-text">
                  No lessons
                </div>
              )}
            </div>
            <br />

            <br />
            <h4>Lesson Report Cards</h4>
            {that.props.reportCards.length > 0 ? (
              <div>
                {this.renderReportCardsBody(this.props.member.id)}
              </div>
            ) : (
              <div className="shadowDepth1 well grey-text center-text">
                No Lesson Report Cards
              </div>
            )}
            <br />
          </div>
        )}
      </div>
    );
  }
}

Member.propTypes = {
  member: PropTypes.object,
  photoUrl: PropTypes.string,
  household: PropTypes.array,
  currentUser: PropTypes.object,
  currentAccount: PropTypes.object
};

export default Member;
